import { isNil } from 'lodash';
import Store from 'redux-store/store';

import { getBrandProfileId } from 'utils/organization';
import { getInfluencerProfileId } from 'utils/influencers';

import {
  CustomDimensions,
  EntityWithIdAndName
} from '../types/custom-dimensions';

type StoreAlias = {
  getState: () => any
};

class CustomDimensionsDataProvider {
  private store: StoreAlias;

  constructor(store: StoreAlias) {
    this.store = store;
  }

  private getState(): any {
    return this.store.getState();
  }

  private getBrandId(): number | undefined {
    const brandId = getBrandProfileId(this.getState()?.organizations?.currentOrganization ?? null);

    return brandId ?? undefined;
  }

  private getInfluencerId(): number | undefined {
    const influencerId = getInfluencerProfileId(
      this.getState()?.organizations?.currentOrganization ?? null
    );

    return influencerId ?? undefined;
  }

  private getOrganizationId(): number | undefined {
    return this.getState()?.organizations?.currentOrganization?.id ?? undefined;
  }

  private getOrganizationType(): CustomDimensions['organizationType'] | undefined {
    const organization = this.getState()?.organizations?.currentOrganization;
    const orgType = organization?.type ?? undefined;
    const organizationSubscriptionType = organization?.subscriptionType ?? '';

    return organizationSubscriptionType || orgType;
  }

  private getUserId(): number | undefined {
    return this.getState()?.account?.currentAccount?.id ?? undefined;
  }

  private getAgencyInfo(): EntityWithIdAndName | undefined {
    return this.getState()?.account?.currentAccount?.agency ?? undefined;
  }

  private getCampaignInfo(): ({ id: number, name: string }) | undefined {
    const briefCampaignInfo = this.getState()?.campaignBrief?.brief ?? null;

    if (
      isNil(briefCampaignInfo) || isNil(briefCampaignInfo.id) || isNil(briefCampaignInfo.name)
    ) {
      return undefined;
    }

    return {
      id: briefCampaignInfo.id,
      name: briefCampaignInfo.name
    };
  }

  getGeneralHitScopeData(): Partial<CustomDimensions> {
    return {
      agencyInfo: this.getAgencyInfo(),
      brandId: this.getBrandId(),
      campaignInfo: this.getCampaignInfo(),
      influencerId: this.getInfluencerId(),
      organizationId: this.getOrganizationId(),
      organizationType: this.getOrganizationType(),
      userId: this.getUserId()
    };
  }
}

export default new CustomDimensionsDataProvider(Store);
